export const OAUTH_STATE_ID = 'oauth-state-id'
export const ACH_FLOW_INITIAL_STEP = 'ach-flow-initial-step'
